/*
 * Eiken : personnalisation par embossage (refonte du 29/09/2026).
 *
 * Remplace le script en fin de snippets/product-template.liquid et le bloc
 * Custom Liquid 66d9d175 dupliqué dans trois modèles de fiche.
 *
 * Règles de l'atelier : majuscules A à Z, chiffres 0 à 9, espaces et points,
 * 10 caractères au maximum.
 *
 * Choix à ne pas défaire :
 * - Le champ n'est rendu que sur les produits embossables (voir le Liquid).
 * - Quand l'embossage n'est pas choisi, le champ est DÉSACTIVÉ. Un champ
 *   désactivé n'est pas envoyé (theme.utils.serialize l'ignore), donc aucune
 *   propriété « Emboss Text » vide ou orpheline ne part avec la commande.
 * - Quand il est choisi, le champ devient `required` : le navigateur bloque
 *   l'envoi du formulaire avant l'événement submit que le thème intercepte.
 * - Tout est limité à la fiche (data-section-id) : aucun sélecteur global,
 *   aucun écouteur sur document.
 */
(function () {
  'use strict';

  var NOT_ALLOWED = /[^A-Z0-9 .]/g;

  function clean(value) {
    // Majuscules et accents retirés (É -> E) : le tampon n'a que A à Z.
    return value.toUpperCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function unique(chars) {
    return chars.filter(function (c, i) { return chars.indexOf(c) === i; });
  }

  function setup(field) {
    if (field.hasAttribute('data-eiken-emboss-ready')) return;
    field.setAttribute('data-eiken-emboss-ready', '');

    var scope = field.closest('[data-section-id]') || field.parentNode;
    var input = field.querySelector('[data-eiken-emboss-input]');
    var counter = field.querySelector('[data-eiken-emboss-count]');
    var error = field.querySelector('[data-eiken-emboss-error]');
    var toggle = scope.querySelector('[data-eiken-emboss-toggle]');
    var optionName = field.getAttribute('data-option-name');
    var valueYes = field.getAttribute('data-value-yes');
    var valueNo = field.getAttribute('data-value-no');
    var max = parseInt(input.getAttribute('maxlength'), 10) || 10;
    var msgRequired = field.getAttribute('data-msg-required');
    var msgChars = field.getAttribute('data-msg-chars');

    // Le sélecteur Oui/Non natif est masqué : le bouton le pilote.
    var fieldset = scope.querySelector('.variant-input-wrap[data-handle="' + field.getAttribute('data-option-handle') + '"]');
    var wrapper = fieldset ? fieldset.closest('.variant-wrapper') : null;
    if (wrapper) wrapper.classList.add('eiken-emboss-wrapper');

    function radios() {
      return Array.prototype.filter.call(scope.querySelectorAll('input[type="radio"]'), function (r) {
        return r.name === optionName;
      });
    }

    function isOpen() {
      var checked = radios().filter(function (r) { return r.checked; })[0];
      return !!checked && checked.value === valueYes;
    }

    function validate() {
      var v = input.value.trim();
      var bad = unique(v.match(NOT_ALLOWED) || []);
      var msg = '';
      if (!input.disabled) {
        if (!v) msg = msgRequired;
        else if (bad.length) msg = msgChars.replace('__CHARS__', bad.join(' '));
      }
      input.setCustomValidity(msg);
      input.setAttribute('aria-invalid', msg ? 'true' : 'false');
      return msg;
    }

    function showError(msg) {
      error.textContent = msg;
      error.hidden = !msg;
    }

    function updateCounter() {
      counter.textContent = input.value.length + '/' + max;
    }

    function render() {
      var open = isOpen();
      field.hidden = !open;
      input.disabled = !open;
      input.required = open;
      if (!open) {
        input.value = '';
        showError('');
      }
      if (toggle) {
        toggle.setAttribute('aria-expanded', String(open));
        toggle.textContent = toggle.getAttribute(open ? 'data-label-open' : 'data-label-closed');
      }
      updateCounter();
      validate();
    }

    if (toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        var target = isOpen() ? valueNo : valueYes;
        radios().forEach(function (r) {
          if (r.value === target && !r.checked) {
            r.checked = true;
            r.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        render();
        if (isOpen()) input.focus();
      });
    }

    // Tout changement de l'option (bouton, retour arrière du navigateur, URL
    // ?variant=) passe par les boutons radio : c'est la seule source de vérité.
    scope.addEventListener('change', function (e) {
      if (e.target && e.target.name === optionName) render();
    });

    input.addEventListener('input', function () {
      var start = input.selectionStart;
      var end = input.selectionEnd;
      var next = clean(input.value);
      if (next !== input.value) {
        input.value = next;
        if (start !== null) input.setSelectionRange(start, end);
      }
      updateCounter();
      var msg = validate();
      // Pendant la frappe, on ne signale que les caractères interdits.
      showError(msg && msg !== msgRequired ? msg : '');
    });

    input.addEventListener('blur', function () {
      input.value = input.value.replace(/\s+/g, ' ').trim();
      updateCounter();
      validate();
    });

    input.addEventListener('invalid', function () {
      showError(validate());
    });

    // Espaces en bord retirés juste avant l'envoi (5 commandes en portaient).
    var form = input.form;
    if (form) {
      form.addEventListener('submit', function () {
        if (!input.disabled) input.value = input.value.replace(/\s+/g, ' ').trim();
      }, true);
    }

    render();
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-eiken-emboss-field]'), setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // L'éditeur de thème recharge les sections sans recharger la page.
  document.addEventListener('shopify:section:load', init);
})();
